import { render } from "./DownloadSpeedRestrictionsTableButton.vue?vue&type=template&id=537cedde&scoped=true"
import script from "./DownloadSpeedRestrictionsTableButton.vue?vue&type=script&lang=js"
export * from "./DownloadSpeedRestrictionsTableButton.vue?vue&type=script&lang=js"

import "./DownloadSpeedRestrictionsTableButton.vue?vue&type=style&index=0&id=537cedde&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537cedde"]])

export default __exports__